/*import { useEffect, useState } from 'react';
import { getCountryOriginBasedOnIp } from '../GlobalFunctions';*/
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { ExternalLink } from '../components/ExternalLink';
import Documents from '../Documents';
import styles from '../SCSS/Footer.module.scss';
import whiteLogo from '../images/pkp-backpack-name-logo.svg';
import cdnLogo from '../images/icons/cdn.png';
import usaLogo from '../images/icons/usa.png';
import uaeLogo from '../images/icons/uae.png';

/*
Component: Footer

The Footer component generates a standardized footer
*/

const Footer = (): JSX.Element => {
  /*const [isUSAddress, setIsUSAddress] = useState(false);
  useEffect(() => {
    async function checkCountry() {
      const country = await getCountryOriginBasedOnIp();

      if (country === 'United States') {
        setIsUSAddress(true);
      } else {
        setIsUSAddress(false);
      }
    }

    checkCountry();
  }, []);`*/
  return (
    <footer className={styles.footer}>
      <nav className={styles.navigation}>
        <section>
          <h1>K12 Resources</h1>
          <p>
            <Link to='/elementary'>Elementary PK-5</Link>
          </p>
          <p>
            <Link to='/secondary'>Middle School 6-8</Link>
          </p>
          <p>
            <Link to='/highschool'>High School 9-12</Link>
          </p>
          <p>
            <Link to='/mypeekaville#top'>myPeekaville</Link>
          </p>
          <p>
            <ExternalLink href={Documents.shopSite} target='_blank'>
              The Peekapals Storybooks
            </ExternalLink>
          </p>
        </section>
        <section>
          <h1>Who It’s For</h1>
          <p>
            <Link to='/districtLead'>For Administrators</Link>
          </p>
          <p>
            <Link to='/educators'>For Educators</Link>
          </p>
          <p>
            <Link to='/counselors'>For Counselors</Link>
          </p>
          <p>
            <Link to='/parents'>For Parents</Link>
          </p>
          <p>
            <Link to='/employeeWellBeing'>For Corporate</Link>
          </p>
        </section>
        <section>
          <h1>Why Peekapak</h1>
          <p>
            <Link to='/about#top'>Our story</Link>
          </p>
          <p>
            <Link to='/careers'>Careers</Link>
          </p>
          <p>
            <Link to='/contact'>Contact Us</Link>
          </p>
          <p>
            <Link to='/press'>Press</Link>
          </p>
          <p>
            <Link to='/privacyPolicy#top'>Privacy</Link>
          </p>
          <p>
            <Link to='/termsOfUse#top'>Terms of Use</Link>
          </p>
        </section>
        <section>
          <h1>Resources</h1>
          <p>
            <Link to='/funding'>Funding & Grants</Link>
          </p>
          <p>
            <ExternalLink href={Documents.blogSite} target='_blank'>
              Webinars
            </ExternalLink>
          </p>
          <p>
            <ExternalLink href={Documents.blogSite} target='_blank'>
              Blog
            </ExternalLink>
          </p>
          <p>
            <ExternalLink href='https://help.peekapak.com' target='_blank'>
              FAQs
            </ExternalLink>
          </p>
          <p>
            <Link to='/contact'>Support</Link>
          </p>
        </section>
        <section className={cx(styles.contactCard, 'vcard')}>
          <figure>
            <object data={whiteLogo} type='image/svg+xml'>
              white backpack word logo
            </object>
            <figcaption className={styles.infoSection}>
              <p
                className='fn org'
                style={{
                  display: 'none',
                }}
              >
                Peekapak Inc.
              </p>
              <p>
                <a className={'email'} href='mailto:hello@peekapak.com'>
                  hello@peekapak.com
                </a>
                <br />
              </p>
              <p className={styles.phoneRow}>
                <a className='tel' href='tel:+18885136418' aria-label='Call Peekapak'>
                  <i className='fas fa-phone-alt' style={{ marginRight: 6 }} />
                  1-888-513-6418
                </a>
              </p>
              <p className={styles.whatsAppRow}>
                <a
                  className='tel'
                  href='https://wa.me/971503689632'
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-label='Chat with Peekapak on WhatsApp'
                >
                  <i className='fab fa-whatsapp' style={{ marginRight: 6 }} />
                  +971503689632
                </a>
              </p>
            </figcaption>
          </figure>
          <figure className={styles.socialMediaIcons}>
            <ExternalLink href='http://facebook.com/peekapak' target='_blank'>
              <i className='fab fa-facebook-f' />
            </ExternalLink>
            <ExternalLink href='http://twitter.com/peekapak' target='_blank'>
              <i className='fab fa-twitter' />
            </ExternalLink>
            <ExternalLink href='https://ca.linkedin.com/company/peekapak' target='_blank'>
              <i className='fab fa-linkedin' />
            </ExternalLink>
            <ExternalLink href='http://instagram.com/peekapak' target='_blank'>
              <i className='fab fa-instagram' />
            </ExternalLink>
            <ExternalLink href='http://youtube.com/peekapak' target='_blank'>
              <i className='fab fa-youtube' />
            </ExternalLink>
          </figure>
        </section>
        <hr />
        <div className={styles.addressContainer}>
          <div className={styles.address}>
            <img src={cdnLogo} /> 192 Spadina Suite 300 Toronto, Ontario, Canada
          </div>
          <div className={styles.address}>
            <img src={usaLogo} /> 447 Broadway, 2nd Floor #1190, New York, NY 10013, United States
          </div>
          <div className={styles.address}>
            <img src={uaeLogo} /> DD-16-121-008, Level 16, Al Khatem Tower, WeWork Hub 71, Abu Dhabi Global Market
            Square, UAE
          </div>
        </div>
      </nav>
      <section className={styles.copyright}>© 2025 Peekapak. All rights reserved.</section>
    </footer>
  );
};

export default Footer;
